import {common as stringsCommon, profileUnauth as strings} from "strings";

import Button from "components/Button";
import MobileNavigationHeader from "components/MobileNavigationHeader";
import PageTitle from "components/PageTitle";

import styles from "./ProfileUnauthPage.module.css";

export default function ProfileUnauthPage() {
  return (
    <>
      <MobileNavigationHeader
        rightLink={{label: stringsCommon.login, to: "/login"}}
      />
      <div className={styles.container}>
        <div>
          <PageTitle className={styles.rx365}>{stringsCommon.rx365}</PageTitle>
          <h1 className={styles.h1}>{strings.description}</h1>
          <Button className={styles.button} to="/register">
            {stringsCommon.register}
          </Button>
        </div>
      </div>
    </>
  );
}
